module.exports = __webpack_public_path__ + "img/mor-logo.3e436497.png";